import { Component } from '@angular/core';

@Component({
  selector: 'app-dialog-add-website',
  templateUrl: '../../templates/dialogs/dialog-add-website.component.html'
})
export class DialogAddWebsiteComponent {
validForm = false;
templates = [{ code: "1", name: "One Pager Sidenav"},{ code: "2", name: "One Pager Topnav"},{ code: "3", name: "Multipage Fullscreen banner"}];

}


// WEBPACK FOOTER //
// /home/gideon/webbest/projects/wb-management-system/frontend/wb-management-system/src/app/assets/components/dialogs/dialog-add-website.component.ts